/**
 *
 * Agenda PlannedTreatments
 *
 */

import {useCallback, useMemo} from "react";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import GlobalMessages from "messages/messages";
import {makeStyles} from "@material-ui/core/styles";
import messages from "containers/AdminAgendaPage/messages";
import {DATE_FORMATS} from "../../utils/Date";
import FormattedDate from "basicComponents/FormattedDate/Formatted";
import history from "../../utils/history";
import IconActionButton from "../../basicComponents/IconActionButton/IconActionButton";
import Edit from "../../images/EditIcon";
import HouseIcon from "basicComponents/Icons/HouseIcon";
import {Link, Typography} from "@material-ui/core";
import moment from "moment";
import DeleteIcon from "images/DeleteIcon";
import { useEffect } from "react";
import { getBearer } from "utils/userStorage";
import { useState } from "react";
import { DEFAULT_LOCALE } from "i18n";

const useStyles = makeStyles(theme => ({
  container: {
    width: "100%",
    border: `solid 1px rgba(0,0,0)`,
    borderRadius: `10px`,
    display: "flex",
    flexDirection: "column",
    marginTop: `1rem`,
    padding: `1rem`,
    alignSelf: "flex-start",
  },
  containerAdmin: {
    width: "100%",
    border: `solid 1px rgba(0,0,0,0.24)`,
    borderRadius: `15px`,
    display: "flex",
    flexDirection: "column",
    marginTop: `1rem`,
    padding: `1rem`,
    alignSelf: "flex-start",
  },
  header: {
    width: "100%",
    fontSize: "1rem",
    color: "gray",
    fontWeight: "bold",
    paddingBottom: theme.spacing(1),
    alignSelf: "center",
    display: "grid",
    gridTemplateColumns: "20px auto 20px",
    borderBottom: "1px solid rgba(0,0,0,0.2)",
  },
  defaultHeader: {
    width: "100%",
    fontSize: "1em",
    textAlign: "center",
    fontWeight: "bold",
    color: "gray",
  },
  headerItem: {
    gridColumnStart: 2,
    gridRowStart: 1,
    justifySelf: "center",
  },
  headerIcon: {
    gridColumnStart: 3,
    justifySelf: "right",
    alignSelf: "center",
  },
  plannedData: {
    marginLeft: "1rem",
    marginBottom: "5px",
    wordBreak: "break",
    fontSize: "1rem",
  },
  practiceData: {
    marginLeft: "1rem",
    marginBottom: "5px",
    fontSize: "1rem",
  },
  practiceDataLabel: {
    marginLeft: "1rem",
  },

  treatmentLabel: {
    display: "flex",
    flexDirection: "row",
    marginLeft: "1rem",
    marginBottom: "5px",
    justifyContent: "space-between",
    fontSize: "1rem",
  },
  treatmentData: {
    flex: 3,
  },
  duration: {
    color: "green",
    width: "75px",
    flex: 1,
  },
  plannedTreatmentTime: {
    alignSelf: "center",
    fontSize: "1rem",
  },
  plannedDataLabel: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "1rem",
  },
  spacer: {
    height: "1rem",
  },
  valueContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    "& > *": {
      fontSize: "13px",
    },

    "& > *:first-child": {
      marginRight: "1rem",
    },
  },
  divider: {
    width: "100%",
    height: "1px",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  flexCol: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  wrapper: {
    width: "100%",
    minWidth: "300px",
    maxWidth: "500px"
  },
  buttonSpacing: {
    marginTop: theme.spacing(1),
  },
}));

function AgendaPlannedTreatment({
  patient,
  treatment,
  practice,
  selectPractice,
  withPracticeInfo = true,
  onDeleteClick,
  onEditClick,
  admin = true,
  newAppointment = false,
  duration
}) {
  const classes = useStyles();

  const handleEdit = () => {
    if (selectPractice) {
      // set practice when clicked this is to handle not having a practice!!
      selectPractice(practice);
      history.push({
        pathname: `/treatment/edit/${patient.id}`,
        // this is to handle the coming fromAdminPanel page to be able to return.
        fromAdmin: true,
        activeTreatment: treatment,
      });
    }
  };

  let [allconfigs,setallconfigs] = useState([])
  let [allendproducttypes,setallendproducttypes] = useState([])
  let [allendproducttreatments,setallendproducttreatments] = useState([])


  useEffect(() => {
    window.getPaul('endProductType_configuration','',0,(data) => {
      setallconfigs(data)
    })
    window.getPaul('endProductType','',0,(data) => {
      setallendproducttypes(data)
    })
    window.getPaul('endProductType_treatment','',0,(data) => {
      setallendproducttreatments(data)
    })
  },[])

  let [alltreatments,setalltreatments] = useState([])

  useEffect(() => {
    //parsetreatmentplan
    // 
    fetch(`${__URLS__["api"]}practices/allTreatments`,{
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Accept-Language":DEFAULT_LOCALE,
        "Authorization": `Bearer ${getBearer()}`,
      },
    })
    .then(res => res.json())
    .then(data => {
      setalltreatments(data)
    })
  },[])

  const hasHomeShipping = useMemo(
    () => {
      if (treatment) {
        return treatment.homeShipping;
      }

      return false;
    },
    [treatment],
  );

  const hasManufacturerOffice = useMemo(
    () => {
      if (treatment) {
        return treatment.manufacturerOffice;
      }

      return false;
    },
    [treatment],
  );

  const treatmentPlanDescription = useMemo(
    () => {
      if (treatment && treatment.treatmentPlan) {
        return treatment.treatmentPlan.description;
      }

      return "";
    },
    [treatment],
  );

  const address = useMemo(
    () => {
      if (patient && patient.address) {
        return patient.address;
      }

      return null;
    },
    [patient],
  );

  const patientAddress = useCallback(
    () => {
      if (!address) {
        return "-";
      }

      let actualAddress = "";

      actualAddress += address.street;

      if (address.house_nr) {
        actualAddress += ` ${address.house_nr}`;

        if (address.house_nr_addendum) {
          actualAddress += ` ${address.house_nr_addendum}`;
        }
      }

      return actualAddress;
    },
    [address],
  );

  const practiceAddress = useCallback(
    () => {
      if (!practice) {
        return "-";
      }

      let actualAddress = practice.street;

      if (practice.house_nr) {
        actualAddress += ` ${practice.house_nr}`;

        if (practice.house_nr_addendum) {
          actualAddress += ` ${practice.house_nr_addendum}`;
        }
      }

      return actualAddress;
    },
    [practice],
  );

  const timeSpan = useMemo(
    () => {
      if (
        !treatment ||
        !treatment.planned_date_time_from ||
        !treatment.planned_date_time_to
      ) {
        return null;
      }

      return (
        <Typography>
          <FormattedDate
            date={treatment.planned_date_time_from}
            format={DATE_FORMATS.HUMAN_READABLE_TIME}
          />
          <FormattedMessage {...GlobalMessages.hoursSmall} />-
          <FormattedDate
            date={treatment.planned_date_time_to}
            format={DATE_FORMATS.HUMAN_READABLE_TIME}
          />
          <FormattedMessage {...GlobalMessages.hoursSmall} />
        </Typography>
      );
    },
    [treatment],
  );

  const treatmentDuration = useMemo(
    () => {
      if (
        !treatment ||
        !treatment.planned_date_time_from ||
        !treatment.planned_date_time_to
      ) {
        return null;
      }

      const from = moment(treatment.planned_date_time_from);
      const to = moment(treatment.planned_date_time_to);

      return moment.duration(to.diff(from));
    },
    [treatment],
  );

  let [drivers,setDrivers] = useState([])

  useEffect(() => {
    fetch(`${__URLS__["api"]}drivers`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getBearer()}`,
      },
    })
      .then((res) => {
        return res.json()
      }).then((res) => {
        setDrivers(res)
      }).catch(() => {
        console.log('failed getting drivers')
      })
  },[])

  if(alltreatments.length > 0 && allconfigs.length > 0 && allendproducttreatments.length > 0 && treatment){
    //maybe get the productorder instead of using the treatment product name
    console.log("agendaplannedtreatment")
    // var ogtreatment = alltreatments.find(t => t.id == treatment.treatmentId)              
    var config = allconfigs.find(c => c.id == treatment.treatmentPlan.endProductTypeConfigurationId)
    var upper = allendproducttypes.find(ept => ept.id == config.upperEndProductTypeId)
    var lower = allendproducttypes.find(ept => ept.id == config.lowerEndProductTypeId)
    var lowerproductnl = lower?.nl
    var upperproductnl = upper?.nl
    // var uppertreatments = allendproducttreatments.filter(ept => ept.endProductTypeId == config.upperEndProductTypeId)
    //   .map(pt => alltreatments.find(t => t.id == pt.treatmentId))//add ordernumber?
    // var lowertreatments = allendproducttreatments.filter(ept => ept.endProductTypeId == config.lowerEndProductTypeId)
    //   .map(pt => alltreatments.find(t => t.id == pt.treatmentId))//add ordernumber?

    // var lowertreatment = lowertreatments.find(t => t.id == ogtreatment.id)
    // var lowi = lowertreatments.findIndex(t => t.id == ogtreatment.id)
    // var upi = uppertreatments.findIndex(t => t.id == ogtreatment.id)

    // if(lowertreatment == null || lowi == -1 || upi == -1){
      
    // }else{
    //   if(lowertreatment.id == ogtreatment.id){
    //     var lowerproductnl = ogtreatment.product_nl
    //     var upperproductnl = uppertreatments[lowi]?.product_nl
    //   }else{
    //     var lowerproductnl = lowertreatment[upi]?.product_nl
    //     var upperproductnl = ogtreatment.product_nl
    //   }
    // }

  }

  return (
    <div style={{background:'white'}} className={classes.wrapper} data-cy="plannedTreatments">
      {treatment && (
        <div className={admin ? classes.containerAdmin : classes.container}>
          <div className={classes.header}>
            <div className={classes.headerItem}>
              <div className={classes.flexCol}>
                {newAppointment ? (
                  <FormattedMessage {...GlobalMessages.appointment} />):
                  <FormattedMessage {...GlobalMessages.appoint} />}
                {timeSpan && timeSpan}
              </div>
            </div>

            {hasHomeShipping && (
              <div className={classes.headerIcon}>
                <HouseIcon />
              </div>
            )}
          </div>

          <div className={classes.valueContainer}>
            <Typography><a href={`/patient/${patient.id}`}>{patient.name}</a></Typography>
            <Typography>
              {patient.internalRef ? patient.internalRef : "-"}
            </Typography>
          </div>
          <div className={classes.valueContainer}>
            <Typography>
              <FormattedMessage {...GlobalMessages.caseNr} />
            </Typography>
            <Typography>
              {treatment.treatmentPlan.caseId || patient.caseId}
            </Typography>
          </div>

          <br />

          {/* here */}
          <div className={classes.valueContainer}>
            <Typography>
              {upperproductnl??""}{" "}
              {treatment.upperImplantCount > 0 && (
                <FormattedMessage
                  {...messages.implant}
                  values={{ count: treatment.upperImplantCount }}
                />
              )}{" "}
              <FormattedMessage {...messages.upperJaw} />
            </Typography>
          </div>

          <div className={classes.valueContainer}>
            <Typography>
              {lowerproductnl??""}{" "}
              {treatment.lowerImplantCount > 0 && (
                <FormattedMessage
                  {...messages.implant}
                  values={{ count: treatment.lowerImplantCount }}
                />
              )}{" "}
              <FormattedMessage {...messages.lowerJaw} />
            </Typography>
          </div>

          <br />

            <div className={classes.valueContainer}>
              <Typography>
                {alltreatments.find(t => t.id == treatment.treatmentId)?.appointment_nl}
              </Typography>
              <Typography>{duration} min.</Typography>
            </div>

          <br />
          <div className={classes.valueContainer}>
            <Typography>
              <FormattedMessage {...messages.comment} />
            </Typography>
            <Typography>{treatmentPlanDescription || patient.patientComments || "-"}</Typography>
          </div>

          <br />

          <div className={classes.valueContainer}>
            <Typography>{patient.care ? patient.care : "-"}</Typography>
            <Typography>
              {patient.insuranceNumber ? patient.insuranceNumber : "-"}
            </Typography>
          </div>

          <br />

          <div className={classes.valueContainer}>
            <Typography>
              <FormattedMessage {...messages.dentist} />
            </Typography>
            <Typography>
              {patient.dentist && patient.dentist.name
                ? patient.dentist.name
                : "-"}
            </Typography>
          </div>

          {/* here */}
          {(() => {
            if(treatment.kpterFirstName == undefined && drivers.length > 0){
              var kpter = drivers.find((d) => d.id == treatment.bumbalDriverId)
              treatment.kpterFirstName = kpter?.first_name
            }
          })()}
          {(treatment.kpterFirstName || treatment.kpterLastName) && (
            <>
              <br />
              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...messages.kpter} />
                </Typography>
                <Typography>
                  {treatment.kpterFirstName} {treatment.kpterLastName}
                </Typography>
              </div>
            </>
          )}
          <br />
          <div className={classes.valueContainer}>
            <Typography>
              <FormattedMessage {...GlobalMessages.withScanner} />
            </Typography>
            <Typography>
              {treatment.withScanner ? (<FormattedMessage {...GlobalMessages.yesButtonText}/>):(<FormattedMessage {...GlobalMessages.noButtonText}/>)}
            </Typography>
          </div>
          {hasHomeShipping && (
            <>
              <div className={classes.divider} />

              <div className={classes.defaultHeader}>
                <div className={classes.headerItem}>
                  <FormattedMessage
                    {...GlobalMessages.homeTreatmentInfoTitle}
                  />
                </div>
              </div>

              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...GlobalMessages.tel_nr} />
                </Typography>
                <Typography>
                  {(patient.address && patient.address.telephone_nr) || "-"}
                </Typography>
              </div>

              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...GlobalMessages.address} />
                </Typography>
                <Typography>{patientAddress()}</Typography>
              </div>

              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...GlobalMessages.cityNoColon} />
                </Typography>
                <Typography>
                  {patient.address
                    ? `${patient.address.zipcode} ${patient.address.city}`
                    : "-"}
                </Typography>
              </div>

              {patient.address.comments && (
              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...GlobalMessages.comments} />
                </Typography>
                <Typography>
                  {patient.address.comments}
                </Typography>
              </div>)}
            </>
          )}
          {hasManufacturerOffice && (
            <>
              <div className={classes.divider} />

              <div className={classes.defaultHeader}>
                <div className={classes.headerItem}>
                  <FormattedMessage
                    {...GlobalMessages.gdsTreatmentInfo}
                  />
                </div>
              </div>

              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...GlobalMessages.tel_nr} />
                </Typography>
                <Typography>
                  {"088-700 5588"}
                </Typography>
              </div>

              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...GlobalMessages.address} />
                </Typography>
                <Typography>{"Ringbaan noord 7"}</Typography>
              </div>

              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...GlobalMessages.cityNoColon} />
                </Typography>
                <Typography>
                  {"5013EA Tilburg"}
                </Typography>
              </div>
            </>
          )}
          {withPracticeInfo && (
            <>
              <div className={classes.divider} />

              <div className={classes.defaultHeader}>
                <div className={classes.headerItem}>
                  <FormattedMessage {...GlobalMessages.dentistInfoTitle} />
                </div>
              </div>

              <div className={classes.valueContainer}>
                <Typography>{practice.name}</Typography>
              </div>

              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...GlobalMessages.tel_nr} />
                </Typography>
                <Typography>{practice.phoneNumber || "-"}</Typography>
              </div>

              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...GlobalMessages.emailNoColon} />
                </Typography>
                <Typography>{practice.email || "-"}</Typography>
              </div>

              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...GlobalMessages.address} />
                </Typography>
                <Typography>{practiceAddress()}</Typography>
              </div>

              <div className={classes.valueContainer}>
                <Typography>
                  <FormattedMessage {...GlobalMessages.cityNoColon} />
                </Typography>
                <Typography>
                  {`${practice.zipcode || "-"} ${practice.city || "-"}`}
                </Typography>
              </div>
            </>
          )}

          <div className={classes.spacer}> </div>
          {(onEditClick || selectPractice) && (
            <IconActionButton
              icon={<Edit />}
              onClick={() => {
                if (onEditClick) {
                  onEditClick(treatment);
                } else if (selectPractice) {
                  handleEdit();
                }
              }}
              id="editAppointmentButton"
            >
              <FormattedMessage {...GlobalMessages.edit} />
            </IconActionButton>
          )}
          {onDeleteClick && (
            <IconActionButton
              className={classes.buttonSpacing}
              icon={<DeleteIcon />}
              onClick={onDeleteClick}
              id="deleteAppointmentButton"
            >
              <FormattedMessage {...GlobalMessages.delete} />
            </IconActionButton>
          )}
        </div>
      )}
    </div>
  );
}

AgendaPlannedTreatment.propTypes = {
  treatment: PropTypes.object,
  practice: PropTypes.object,
  patient: PropTypes.object,
};

export default AgendaPlannedTreatment;
